import React, { useState, useEffect, useRef } from 'react'; // 1. Import useEffect, useRef
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navRef = useRef(); // 2. Create a ref for the nav element

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  }

  // --- 3. Add useEffect for Click Outside ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the navRef element
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    // Add listener only if the menu is open
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      // Remove listener if menu is closed
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Cleanup function to remove listener when component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]); // Re-run effect when isMobileMenuOpen changes
  // --- End useEffect ---


  return (
    // 4. Attach the ref to the nav element
    <nav ref={navRef} className={`main-nav ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      <button className="hamburger-button" onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`nav-links-container ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="nav-links-left">
          <NavLink className="nav-link" to="/" onClick={handleLinkClick}>
            GPA Calculator
          </NavLink>
          <NavLink className="nav-link" to="/faculty" onClick={handleLinkClick}>
            Faculty Reviews
          </NavLink>
          <NavLink className="nav-link" to="/timetable" onClick={handleLinkClick}>
            Timetable Maker
          </NavLink>
          <NavLink className="nav-link" to="/add-faculty" onClick={handleLinkClick}>
            Add Faculty
          </NavLink>
          <NavLink className="nav-link" to="/lostfound" onClick={handleLinkClick}>
            Lost & Found
          </NavLink>
          <NavLink className="nav-link" to="/cabin-finder" onClick={handleLinkClick}>
            Cabin Finder
          </NavLink>
          <NavLink className="nav-link" to="/whatsapp-groups" onClick={handleLinkClick}>
            WhatsApp Groups
          </NavLink>
          <NavLink className="nav-link" to="/feedback">
            Feedback
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;